import {Selectors} from '../Settings';

import PartnersList from '../Elements/PartnersList';
import PartnersLetters from '../Elements/PartnersLetters';

class PartnerController {
	constructor() {
		this.initializeElements();
	}

	initializeElements() {
		//this.initializeElement(Selectors.partnersList, PartnersList);
		//this.initializeElement(Selectors.partnersLetters, PartnersLetters);
	}

	initializeElement(elementSelector, elementClass) {
		let $element = $(elementSelector);
		if ($element.length > 0) {
			new elementClass($element);
		}
	}
}

export default PartnerController;